import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3f83cb7b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=3f83cb7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f83cb7b",
  null
  
)

export default component.exports